<template>
  <div>
    <template v-if="$membershipHasPermissionTo('create pipelines')">
      <div class="bg-white p-4 rounded border border-gray-400 space-x-2">
        <CreateNewPipelineAction :account-id="accountId" :projectId="projectId" />

        <BaseButton primary @click="setModalLinkExistingVisible(true)"> Add Existing </BaseButton>
      </div>
    </template>

    <Pipelines
      :loading="pending"
      :project-uuid="projectId"
      :pipelines="pipelines"
      class="mt-4"
      @pipeline-delete="removePipeline"
    />

    <template v-if="$membershipHasPermissionTo('create pipelines')">
      <portal v-if="modalLinkExistingVisible" to="app-dialog">
        <ModalLinkExisting
          :account-uuid="$route.params.accountId"
          :project-uuid="projectId"
          @closed="modalLinkExistingVisible = false"
        />
      </portal>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import Pipelines from '@/components/ProjectPipelines/PipelineList.vue';
import ModalLinkExisting from '@/components/ProjectPipelines/ModalLinkExisting.vue';
import components from './pipelines/components';

export default {
  components: {
    Pipelines,
    ModalLinkExisting,
    ...components,
  },

  props: {
    accountId: { type: String, required: true },
    projectId: { type: String, required: true },
  },

  data: () => ({
    pending: false,
    modalCreateVisible: false,
    modalLinkExistingVisible: false,
  }),

  computed: {
    ...mapState('ui/projectPipelines', ['ids']),
    ...mapGetters('ui/projectPipelines', ['pipelines']),
  },

  created() {
    this.init();
  },

  destroyed() {
    this.setIds([]);
    this.setMeta(null);
    this.setLinks(null);
  },

  methods: {
    ...mapActions('ui/projectPipelines', {
      loadPipelines: 'load',
      storePipeline: 'store',
      deletePipeline: 'destroy',
    }),

    ...mapMutations('ui/projectPipelines', ['setIds', 'setMeta', 'setLinks']),

    async init() {
      const { projectId } = this;

      this.pending = true;

      try {
        const { pipelineUuids } = await this.loadPipelines({ projectUuid: projectId });

        if (pipelineUuids.length === 1 && !this.$membershipHasPermissionTo('create pipelines')) {
          this.$router.replace({
            name: 'accounts.pipelines.pipelineUuid',
            params: {
              accountId: this.accountId,
              pipelineUuid: pipelineUuids[0],
            },
          });
        } else {
          this.pending = false;
        }
      } catch (error) {
        this.pending = false;
      }
    },

    setModalCreateVisible(bool) {
      this.modalCreateVisible = bool;
    },

    setModalLinkExistingVisible(bool) {
      this.modalLinkExistingVisible = bool;
    },

    async removePipeline(pipelineUuid) {
      const { projectId } = this;

      try {
        await this.deletePipeline({ projectUuid: projectId, pipelineUuid });
        this.resetAction();
      } catch (error) {
        //
      }
    },
  },
};
</script>
